import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { generateAdminRouteConfigs } from '@app/components/Routes/admin-route-generator';
import {
  lazyApp,
  lazyCreateCaseModal,
  lazyCustomCallback,
  lazyDashboard,
  lazyFeatureFlags,
  lazyLogin,
  lazyRedirectToAdminPersonal,
} from '@app/components/Routes/lazy-routes';
import requiredAuthLoader from '@app/components/Routes/required-auth-loader';
import { SecurityLayout } from '@app/components/Routes/security-layout';

import { RequiredAuth } from './secure-route';
import { CALLBACK_PATH } from '../LoginWidget/config';

const router = createBrowserRouter([
  {
    element: <SecurityLayout />,
    children: [
      {
        path: CALLBACK_PATH,
        lazy: lazyCustomCallback,
      },
      {
        path: '/login',
        lazy: lazyLogin,
      },
      {
        path: '/',
        element: <RequiredAuth />,
        loader: requiredAuthLoader,
        children: [
          {
            lazy: lazyApp,
            children: [
              // Dynamic Admin Routes - generated from admin-config.ts
              ...generateAdminRouteConfigs(),
              {
                index: true,
                lazy: lazyDashboard,
              },
              {
                path: ':panelId/ref/:refId',
                lazy: lazyDashboard,
              },
              {
                path: ':panelId/filter/:filterId',
                lazy: lazyDashboard,
              },
              {
                path: ':panelId/:subNavId?/:id?',
                lazy: lazyDashboard,
              },
              {
                path: 'case/:jobId?',
                lazy: lazyDashboard,
              },
              {
                path: ':panelId/create',
                lazy: lazyCreateCaseModal,
              },
              {
                path: ':panelId/edit/*',
                lazy: lazyCreateCaseModal,
              },
              {
                path: ':panelId/:id/create',
                lazy: lazyCreateCaseModal,
              },
              {
                path: 'admin/feature-flags',
                lazy: lazyFeatureFlags,
              },
              {
                path: ':panelId/profile',
                lazy: lazyRedirectToAdminPersonal,
              },
            ],
          },
        ],
      },
    ],
  },
]);

export default router;
